import React, { useEffect, useState } from 'react';
import './skills.css';

const Skills = () => {
    const [skills, setSkills] = useState([]);

    useEffect(() => {
        fetch('/upload/data/skills.json')
            .then((res) => res.json())
            .then((data) => setSkills(data))
            .catch((err) => console.error('Failed to load skills:', err));
    }, []);

    return (
        <section id="skills" className="skills-section-3d">
            <div className="skills-container-3d">
                <div className="skills-header-3d">
                    <h2 className="skills-title-3d">Skills & Technologies</h2>
                    <p className="skills-subtitle-3d">My technical expertise and tools I work with</p>
                </div>

                <div className="skills-single-box-3d">
                    <div className="skills-content-3d">
                        {skills.map((skill, index) => (
                            <div
                                key={skill.id}
                                className="skill-item-3d"
                                style={{
                                    animationDelay: `${index * 0.1}s`
                                }}
                            >
                                <div className="skill-item-icon-3d">{skill.icon}</div>
                                <div className="skill-item-content-3d">
                                    <div className="skill-item-header-3d">
                                        <h3 className="skill-item-title-3d">{skill.title}</h3>
                                    </div>
                                    <p className="skill-item-description-3d">{skill.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;